var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.933 16.933",
    id: "PdfFile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.968,
    transform: "matrix(1.03366 0 0 1.03333 -2.911 3.935)",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M 4.9217235,-3.8085938 A 0.25603411,0.25603411 0 0 0 4.6658641,-3.5527344 V 12.322266 a 0.25603411,0.25603411 0 0 0 0.2558594,0.255859 H 17.093598 a 0.25603411,0.25603411 0 0 0 0.255859,-0.255859 V 1.3886719 a 0.25603411,0.25603411 0 0 0 -0.07227,-0.1796875 l -4.796875,-4.9179688 v -0.00195 a 0.25600851,0.25600851 0 0 0 -0.01953,-0.019531 0.25600851,0.25600851 0 0 0 -0.02149,-0.019531 0.25600851,0.25600851 0 0 0 -0.02344,-0.017578 0.25600851,0.25600851 0 0 0 -0.02344,-0.013672 0.25600851,0.25600851 0 0 0 -0.01367,-0.00586 0.25600851,0.25600851 0 0 0 -0.02539,-0.00977 0.25600851,0.25600851 0 0 0 -0.01367,-0.00391 0.25600851,0.25600851 0 0 0 -0.0059,0 0.25600851,0.25600851 0 0 0 -0.03711,-0.00586 0.25600851,0.25600851 0 0 0 -0.01367,-0.00195 0.25600851,0.25600851 0 0 0 -0.0059,0 h -0.0078 z m 0.2558594,0.5117188 h 6.9902341 l 4.669922,4.7890625 V 12.066406 H 5.1775829 Z",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M 12.269531 -3.8085938 A 0.25603411 0.25603411 0 0 0 12.021484 -3.5527344 L 12.021484 1.3886719 A 0.25603411 0.25603411 0 0 0 12.277344 1.6445312 L 17.09375 1.6445312 A 0.25603411 0.25603411 0 0 0 17.277344 1.2089844 L 12.460938 -3.7304688 A 0.25603411 0.25603411 0 0 0 12.269531 -3.8085938 z M 12.533203 -2.921875 L 16.488281 1.1328125 L 12.533203 1.1328125 L 12.533203 -2.921875 z ",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      lineHeight: 2,
      InkscapeFontSpecification: "Calibri",
      textAlign: "center"
    },
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.265,
    "aria-label": "PDF",
    fontFamily: "Calibri",
    fontSize: 5.292,
    opacity: 0.99,
    textAnchor: "middle",
    className: "colorStroke000000 svgStroke"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#437ef7",
    stroke: "none",
    d: "M6.6450719 12.800251q0 .250631-.082682.45217-.082682.201538-.2377118.343648-.1524455.14211-.3772381.219625-.2222088.07752-.5322676.07752h-.379822v1.204061q0 .02067-.012919.03617-.010335.0155-.036174.02584-.023254.0078-.067179.01292-.041341.0078-.1059367.0078-.064596 0-.1085206-.0078-.041341-.0052-.067179-.01292-.025838-.01033-.036174-.02584-.010335-.0155-.010335-.03617v-3.085085q0-.103352.05426-.147277.05426-.04392.1214397-.04392h.715719q.1085206 0 .2067058.01033.1007691.0078.2351279.03876.1369427.02842.2764691.111105.1421103.0801.2402956.198954.098185.118856.1498617.276469.05426.155029.05426.343648zm-.467672.03617q0-.204122-.077515-.341065Q6.0249543 12.358418 5.9112661 12.291238 5.8001617 12.224059 5.678722 12.205972 5.5598662 12.187885 5.446178 12.187885H5.0353501v1.341005h.4004926q.2015382 0 .3333132-.05168.1343588-.05168.2247926-.14211.090434-.09302.1369426-.219625.046509-.129191.046509-.279053zM9.900689 13.443623q0 .434083-.1111044.759644-.1111044.322978-.3255617.537436-.2118735.211873-.5219323.31781Q8.6320319 15.16445 8.2031172 15.16445H7.4951497q-.059428 0-.1136882-.03876-.051677-.04134-.051677-.14211V12.00185q0-.100769.051677-.139526.05426-.04134.1136882-.04134h.7570602q.4340823 0 .7338057.113688.2997235.111104.5012617.322978.2041221.209289.307475.509013.1059367.299723.1059367.676961zm-.467672.01809q0-.271301-.067179-.503845-.067179-.235128-.2118735-.405661-.1421102-.170532-.3617352-.266133-.219625-.0956-.5658573-.0956h-.452169v2.60191h.4573367q.320394 0 .540019-.0801.219625-.0801.3669029-.245464.1472779-.165364.219625-.413411.074931-.250631.074931-.591696zM12.342402 12.012185q0 .04909-.0052.08527-.0052.03617-.01809.05943-.01292.02067-.031.03101-.0155.01034-.03359.01034H11.02982v1.136882h1.157552q.01809 0 .03359.01033.01809.0078.03101.02842.01292.02067.01809.05684.0052.03359.0052.08785 0 .04909-.0052.08527-.0052.03359-.01809.05684-.01292.02067-.03101.03359-.0155.01034-.03359.01034H11.02982v1.39268q0 .01809-.01034.03617-.01033.0155-.03617.02584-.02584.0078-.06718.01292-.04134.0078-.10852.0078-.06201 0-.105937-.0078-.04392-.0052-.06976-.01292-.02584-.01033-.03617-.02584-.01033-.01809-.01033-.03617v-3.09542q0-.100769.05168-.139526.05426-.04134.113688-.04134h1.503785q.01809 0 .03359.01033.01809.01034.031.03359.01292.02325.01809.06201.0052.03617.0052.08527z",
    fontWeight: 400,
    className: "color000000 svgShape"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.c2180ed2d2e25581f7298b056a964254.svg";
export { ForwardRef as ReactComponent };